var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestionmarkcircle = function SvgQuestionmarkcircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 33,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#questionmarkcircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#323232",
    d: "M7.333 20.5h1.334v-1.333H7.333zM8 9.835a6.67 6.67 0 0 0-6.667 6.667A6.669 6.669 0 0 0 8 23.167a6.67 6.67 0 0 0 6.667-6.666A6.67 6.67 0 0 0 8 9.834m0 12a5.34 5.34 0 0 1-5.333-5.333A5.34 5.34 0 0 1 8 11.167a5.34 5.34 0 0 1 5.333 5.334A5.34 5.34 0 0 1 8 21.834m0-9.333a2.666 2.666 0 0 0-2.667 2.666h1.334c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333c0 1.334-2 1.167-2 3.334h1.334c0-1.5 2-1.667 2-3.334A2.666 2.666 0 0 0 8 12.501"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "questionmarkcircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8.5h16v16H0z"
  })))));
};
export default SvgQuestionmarkcircle;